import { Box, IconButton } from "@mui/material";
import React from "react";
import Markdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import remarkGfm from "remark-gfm";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "katex/dist/katex.min.css";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

export default function MarkdownBlock({
  markdownContent,
  rawCopyButtonColor = "black",
  canCopyCode = true,
  style,
  onCopy = () => {},
}) {
  
  function convertLatexDelimiters(markdown) {
    markdown = markdown.replace(/\\\[/g, "$$");
    markdown = markdown.replace(/\\\]/g, "$$");
    markdown = markdown.replace(/\\\(/g, "$$");
    markdown = markdown.replace(/\\\)/g, "$$");
    return markdown;
  }

  markdownContent = convertLatexDelimiters(markdownContent);

  return (
    <div style={style}>
      <Markdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[[rehypeKatex, { throwOnError: false, output: "html" }]]}
        components={{
          code(props) {
            const { children, className, node, ...rest } = props;
            const match = /language-(\w+)/.exec(className || "");
            return match ? (
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <SyntaxHighlighter
                  {...rest}
                  children={String(children).replace(/\n$/, "")}
                  language={match[1]}
                  PreTag="div"
                  style={vscDarkPlus}
                />
                {canCopyCode && (
                  <CopyToClipboard text={String(children)}>
                    <IconButton
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                      }}
                      onClick={onCopy}
                    >
                      <ContentCopyIcon
                        sx={{
                          color: rawCopyButtonColor,
                        }}
                      />
                    </IconButton>
                  </CopyToClipboard>
                )}
              </Box>
            ) : (
              <code
                className="inline-code"
                style={{
                  backgroundColor: "rgb(30, 30, 30)",
                  padding: 2,
                  borderRadius: 4,
                }}
              >
                {children}
              </code>
            );
          },
        }}
      >
        {markdownContent}
      </Markdown>
    </div>
  );
}
